document
  .querySelector("button[name='add_bundle_custom']")
  .addEventListener("click", function (e) {
    // Get the active bundle item
    this.classList.add("btn--loading");
    this.setAttribute("disabled", "disabled");
    var btnForm = this;
    const activeItem = document.querySelector('.custom_bundle_item.active');
    if (activeItem) {
      // var cpSizeActive = activeItem.querySelectorAll('.cp_size_select.active');
      // // Final array to store items
      // let itemsArray = [];
      // cpSizeActive.forEach((bunelitem)=>{
      //   // Get variant id from selected option
      //   let variantId = bunelitem.value;  // replace later with correct variant ID

      //   // Push into array
      //   itemsArray.push({
      //     id: variantId,
      //     quantity: 1
      //   });
      // });

      const bundleBlock = document.querySelector('.product-single .custom_bundle_block');
      let itemsArray = [];

      // Global subscription toggle checked che k nai
      const subscribeCheckbox = document.querySelector('.pt-checkbox__input');
      const isSubscribed = subscribeCheckbox ? subscribeCheckbox.checked : false;

      if (
          bundleBlock &&
          getComputedStyle(bundleBlock).display !== 'none' &&
          getComputedStyle(bundleBlock).visibility !== 'hidden' &&
          getComputedStyle(bundleBlock).opacity !== '0'
      ) {
        var cpSizeActive = activeItem.querySelectorAll('.cp_size_select.active');

        cpSizeActive.forEach((bunelitem) => {
          let itemObj = {
            id: bunelitem.value,
            quantity: 1
          };

          // Product-wise selling plan id — liquid thi data-selling-plan-id attribute ma set thayelu
          if (isSubscribed) {
            const sellingPlanId = bunelitem.dataset.sellingPlanId;
            if (sellingPlanId && sellingPlanId.trim() !== '') {
              itemObj.selling_plan = sellingPlanId;
            }
          }

          itemsArray.push(itemObj);
        });
      }

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          var tempShippingProtect = 0;
          if (cart.items.length > 0) {
            cart.items.forEach(function(itemtemp) {
              //console.log("item.id-pdp->", itemtemp.id)
              if(itemtemp.properties['_type'] === 'shipping_product') {
                tempShippingProtect = 1; // Shipping product exists
              }
            });
            
            //console.log("tempShippingProtect--PDP->", tempShippingProtect);
            if (tempShippingProtect == 0) {
              var properties = {};
              properties['_type'] = 'shipping_product';
              itemsArray.push({
                id: '54859742904695',
                quantity: 1,
                properties:properties
              });
            }
          }
          else{
            //console.log("elset--->")
            var properties = {};
            properties['_type'] = 'shipping_product';
            itemsArray.push({
              id: '54859742904695',
              quantity: 1,
              properties:properties
            });
            //console.log("item---->", items)
          }
        }
      });
      
      setTimeout(function(){
        console.log({itemsArray})
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: itemsArray }),
        })
        .then((response) => {
          if (!response.ok) {
            alert('Cart Error : Variant can only be purchased with a selling plan.');
            return false;
          }
          theme.ajaxCart.update();
          console.log("btnForm---<", btnForm)
          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
          
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);

          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
        });
      },1000);
    }
    else{
      btnForm.classList.remove("btn--loading");
      btnForm.removeAttribute("disabled");
    }
});

